const SET_USER = 'user/SET_USER';


export default function reducer(state = null, action) {
    switch (action.type) {
        case SET_USER:
            return action.user;

        default:
            return state;
    }
}


export const setUser = user => ({type: SET_USER, user});



// WEBPACK FOOTER //
// ./src/ducks/user.js